<template>
  <div :class="['comment-item', `level-${level}`]" :style="{ marginLeft: level > 0 ? '20px' : '0' }">
    <head-image :name="comment.nickName" :size="avatarSize" :url="comment.headImage"></head-image>
    <div class="comment-content">
      <div class="comment-text-line">
        <span class="comment-user" @click="onUserClick(comment)">{{ comment.nickName }}</span>
        <span v-if="comment.toUserNickName" class="reply-to">
          <i class="el-icon-d-arrow-right"></i> 回复 
        </span>
        <span v-if="comment.toUserNickName" class="reply-user" @click="onUserClick(getParentComment())">
          {{ comment.toUserNickName }}
        </span>
        <span class="comment-text">: {{ comment.content }}</span>
      </div>

      <!-- 评论附件图片 -->
      <div class="comment-images" v-if="comment.attachments && comment.attachments.length > 0">
        <div
          class="comment-image"
          v-for="(attachment, index) in comment.attachments"
          :key="`attachment-${attachment.id || index}`"
          @click="previewImage(attachment.thumbUrl || attachment.fileUrl)"
        >
          <img :src="attachment.thumbUrl || attachment.fileUrl" />
        </div>
      </div>

      <div class="comment-actions">
        <span class="comment-time">{{ formatTime(comment.createdTime) }}</span>
        <el-tag
          v-if="comment.userId === userStore.userInfo.id && comment.auditStatus === 0"
          size="mini"
          type="warning"
          class="audit-tag"
        >待审核</el-tag>
        <el-tag
          v-if="comment.userId === userStore.userInfo.id && comment.auditStatus === 2"
          size="mini"
          type="danger"
          class="audit-tag"
        >审核拒绝</el-tag>
        <span
          v-if="!shouldHideReply(comment)"
          class="reply-comment"
          @click="onReply(comment)"
        >回复</span>
        <span v-if="comment.userId === userStore.userInfo.id" class="delete-comment" @click="onDelete(comment.id)">删除</span>
      </div>

      <!-- 递归显示子评论 -->
      <div class="sub-comments" v-if="hasChildren">
        <comment-item
          v-for="childComment in childComments"
          :key="`comment-${childComment.id}`"
          :comment="childComment"
          :all-comments="allComments"
          :moment="moment"
          :level="level + 1"
          @reply="onReplyChild"
          @delete="onDelete"
          @user-click="onUserClick"
          @preview-image="previewImage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
  name: 'CommentItem',
  components: {
    HeadImage
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    allComments: {
      type: Array,
      required: true
    },
    moment: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  computed: {
    avatarSize() {
      return this.level === 0 ? 40 : 35;
    },
    // 获取子评论
    childComments() {
      return this.allComments.filter(c => c.parentId === this.comment.id);
    },
    hasChildren() {
      return this.childComments.length > 0;
    },
    
  },
  methods: {
    // 回复评论
    // onReply(comment) {
    //   this.$emit('reply', comment, this.moment);
    // },
    // 判断是否应该隐藏回复按钮（不能回复自己的评论）
    shouldHideReply(comment) {
      const currentUserId = this.userStore.userInfo.id;
      console.log("???",currentUserId,comment.userId)
      
      // 如果当前用户ID不存在，显示回复按钮
      if (!currentUserId) return false;
      
      // 如果是自己发的评论，则隐藏回复按钮（不能回复自己）
      return comment.userId === currentUserId;
    },
    formatTime(time) {
      if (!time) return '';
      const now = new Date();
      const timestamp = new Date(time);
      const diff = now - timestamp;

      const minute = 60 * 1000;
      const hour = 60 * minute;
      const day = 24 * hour;

      if (diff < minute) {
        return '刚刚';
      } else if (diff < hour) {
        return Math.floor(diff / minute) + '分钟前';
      } else if (diff < day) {
        return Math.floor(diff / hour) + '小时前';
      } else if (diff < day * 2) {
        return '昨天';
      } else {
        const date = new Date(time);
        return `${date.getMonth() + 1}月${date.getDate()}日`;
      }
    },
    // 获取父评论信息（用于显示@谁）
    getParentComment() {
      if (!this.comment.parentId || this.comment.parentId === this.comment.id) {
        return null;
      }
      return this.allComments.find(c => c.id === this.comment.parentId);
    },
    // 回复评论
    onReply(comment) {
      this.$emit('reply', comment, this.moment);
    },
    // 回复子评论
    onReplyChild(comment, moment) {
      this.$emit('reply', comment, moment);
    },
    // 删除评论
    onDelete(commentId) {
      this.$emit('delete', commentId);
    },
    // 用户点击事件
    onUserClick(user) {
      this.$emit('user-click', user);
    },
    // 预览图片
    previewImage(imageUrl) {
      this.$emit('preview-image', imageUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.comment-item {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
  font-size: var(--im-font-size);
  align-items: flex-start;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  background: rgba(255, 252, 243, 0.42);
  border: 0.5px solid var(--hairline-soft);
  transition: background 0.2s ease;

  &:hover { background: rgba(255, 252, 243, 0.78); }

  &:last-child { margin-bottom: 0; }

  .comment-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;

    .comment-text-line {
      line-height: 1.6;
      letter-spacing: -0.2px;
      color: var(--im-text-color);

      .comment-user {
        color: var(--aurora-blue);
        font-weight: 600;
        cursor: pointer;
        transition: color 0.2s ease;
        &:hover { color: var(--aurora-purple); text-decoration: none; }
      }

      .reply-to {
        color: var(--im-text-color-lighter);
        margin: 0 4px;
        font-size: var(--im-font-size-small);
      }

      .reply-user {
        color: var(--aurora-purple);
        font-weight: 600;
        cursor: pointer;
        transition: color 0.2s ease;
        &:hover { color: var(--aurora-blue); }
      }

      .comment-text {
        color: var(--im-text-color);
      }
    }

    /* 评论图片 */
    .comment-images {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;

      .comment-image {
        width: 80px;
        height: 80px;
        border-radius: var(--radius-sm);
        overflow: hidden;
        cursor: pointer;
        border: 0.5px solid var(--hairline-soft);
        box-shadow: 0 1px 2px rgba(31, 31, 35, 0.05);

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
          &:hover { transform: scale(1.05); }
        }
      }
    }

    .comment-actions {
      display: flex;
      gap: 12px;
      align-items: center;
      font-size: var(--im-font-size-small);

      .comment-time {
        color: var(--im-text-color-lighter);
      }

      .audit-tag {
        padding: 0 6px;
        border-radius: var(--radius-xs) !important;
        vertical-align: middle;
      }

      .reply-comment {
        color: var(--im-text-color-secondary);
        cursor: pointer;
        transition: color 0.18s ease;
        &:hover { color: var(--aurora-blue); }
      }

      .delete-comment {
        color: var(--im-text-color-secondary);
        cursor: pointer;
        transition: color 0.18s ease;
        &:hover { color: #FF3B30; }
      }
    }

    /* 子评论容器 */
    .sub-comments {
      margin-top: 10px;
      border-left: 2px solid;
      border-image: linear-gradient(180deg, var(--aurora-blue), var(--aurora-purple), var(--aurora-pink)) 1;
      padding-left: 14px;
    }
  }
}

/* 不同层级的样式调整 */
.comment-item.level-1 {
  .comment-content {
    .comment-text-line {
      font-size: 12px;
    }
    
    .comment-actions {
      font-size: 11px;
      gap: 10px;
    }
  }
}

.comment-item.level-2 {
  .comment-content {
    .comment-text-line {
      font-size: 12px;
    }
    
    .comment-actions {
      font-size: 11px;
      gap: 8px;
    }
    
    .comment-images .comment-image {
      width: 60px;
      height: 60px;
    }
  }
}

.comment-item.level-3,
.comment-item.level-4,
.comment-item.level-5 {
  .comment-content {
    .comment-text-line {
      font-size: 11px;
    }
    
    .comment-actions {
      font-size: 10px;
      gap: 6px;
    }
    
    .comment-images .comment-image {
      width: 50px;
      height: 50px;
    }
  }
}
</style>